import {t} from "../../i18n";
import {Component, PropsWithChildren} from 'react';

/** A failed route download should leave a way to recover on an unreliable connection. */
export default class PageLoadBoundary extends Component<PropsWithChildren, {failed: boolean}> {
    state = {failed: false};

    static getDerivedStateFromError() {
        return {failed: true};
    }

    render() {
        if (!this.state.failed) return this.props.children;
        return <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center" role="alert">
            <p>{t("common.pageError")}</p>
            <button type="button" className="rounded-sm border px-4 py-2" onClick={() => window.location.reload()}>{t("common.retry")}</button>
        </div>;
    }
}
